import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './LoginForm.scss';
import API_URLS from '../../summaryapi/apiUrls';

const ProviderLoginPage = ({ onLogin }) => {
  const [mobile_number, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!mobile_number || !password) {
      setError('Please fill in both fields.');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(API_URLS.ProviderLogin.url, { mobile_number, password });
      console.log('API Response:', response.data);

      if (response.data.status) {
        const providerId = response.data.provider_id;
        console.log('Provider ID:', providerId);

        // Encode provider_id using Base64 and store it in session storage
        const encodedProviderId = btoa(providerId);
        sessionStorage.setItem('provider_id', encodedProviderId);
        console.log('Stored Provider ID:', sessionStorage.getItem('provider_id'));

        onLogin(providerId); // Update auth state
        navigate('/'); // Navigate to Dashboard
      } else {
        setError(response.data.message || 'Login failed. Please try again.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError('Error occurred during login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-screen">
        <div className="login-content">
          <h4>Home Services Provider Login</h4>
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="input-group">
              <input
                type="text"
                className="input-field"
                placeholder="Mobile Number"
                value={mobile_number}
                onChange={(e) => setMobileNumber(e.target.value)}
                required
                aria-label="Mobile Number"
                autoFocus
              />
            </div>
            <div className="input-group">
              <input
                type="password"
                className="input-field"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                aria-label="Password"
              />
            </div>
            {error && <div className="error-message">{error}</div>}
            <button type="submit" className="submit-button-login" disabled={loading}>
              {loading ? (
                <span className="loading-text">Logging in...</span>
              ) : (
                <>
                  <span className="button-text">Login</span>
                  <i className="button-icon fas fa-chevron-right"></i>
                </>
              )}
            </button>
          </form>
        </div>
        <div className="login-background">
          <span className="background-shape shape1"></span>
          <span className="background-shape shape2"></span>
          <span className="background-shape shape3"></span>
          <span className="background-shape shape4"></span>
        </div>
      </div>
    </div>
  );
};

export default ProviderLoginPage;
